'use client';

import { useState } from 'react';
import { ContactForm } from '@/components/ContactForm';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogTrigger } from '@/components/ui/dialog';
import { cn } from '@/lib/utils';
import { components } from '@/types/strapi';

export const DemoPopup = ({
	buttonText = 'Schedule Demo',
	variant = 'outline',
	className = cn(
		'border-[#E0A80C] bg-[#E0A80C] text-white hover:bg-[#E0A80C]/90 hover:border-[#E0A80C]/90',
	),
}: {
	buttonText?: string;
	variant?: components['schemas']['SharedButtonComponent']['variant'];
	className?: string;
}) => {
	const [isOpen, setIsOpen] = useState(false);
	return (
		<Dialog open={isOpen} onOpenChange={setIsOpen}>
			<DialogTrigger asChild>
				<Button size="lg" variant={variant} className={className}>
					{buttonText}
				</Button>
			</DialogTrigger>
			<DialogContent className="m-0 p-0">
				{/* <DialogTitle className="text-center">Schedule Demo</DialogTitle> */}
				<ContactForm />
			</DialogContent>
		</Dialog>
	);
};
